import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MdEmail, MdArrowBack } from 'react-icons/md';
import { forgotPassword, clearForgotPasswordState } from '../redux/actions/authActions';

const ForgotPassword = ({ onBackToLogin }) => {
  const dispatch = useDispatch();
  const { forgotPassword: forgotPasswordState } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');

  useEffect(() => {
    // Clear state when component mounts
    dispatch(clearForgotPasswordState());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(forgotPassword(email));
  };

  if (forgotPasswordState.success) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <img 
              src="https://washi.s3.amazonaws.com/RiskReport360.png"
              alt="Risk Report360 Logo" 
              style={{ height: "100px", width: "170px" }}
              loading="lazy"
              className="mb-0"
            />
            <h1 className="login-title">Check Your Email</h1>
            <p className="login-subtitle">We've sent a password reset link to {email}</p>
          </div>
          
          <button 
            onClick={onBackToLogin}
            className="back-to-login-btn"
          >
            <MdArrowBack />
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="https://washi.s3.amazonaws.com/RiskReport360.png"
            alt="Risk Report360 Logo" 
            className="login-logo"
          />
          <h1 className="login-title">Forgot Password</h1>
          <p className="login-subtitle">Enter your email to reset your password</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <div className="input-wrapper">
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>
            {forgotPasswordState.error && (
              <div className="error-message">{forgotPasswordState.error}</div>
            )}
          </div>
          
          <button type="submit" className="login-btn" disabled={forgotPasswordState.loading}>
            {forgotPasswordState.loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          <button 
            type="button"
            onClick={onBackToLogin}
            className="back-to-login-btn"
          >
            <MdArrowBack />
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;